// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__336A0","title":"Images90_title__K9hQy","images":"Images90_images__20Ak4"};